import { useMediaQuery } from '@chakra-ui/media-query';

const useMobile = () => {
  const [isMobile] = useMediaQuery('(max-width: 768px)');

  return { isMobile };
};

export default useMobile;
